export default function filterItems() {
  class Toggle {
    constructor(domNode) {
      this.toggleItem = domNode;

      this.buttonEl = this.toggleItem.querySelector('button, [role="button"]');

      const controlsId = this.buttonEl.getAttribute('aria-controls');
      this.contentEl = document.getElementById(controlsId);

      this.open = this.buttonEl.getAttribute('aria-expanded') === 'true';

      this.buttonEl.addEventListener('click', this.onButtonClick.bind(this));

      this.toggleItem.addEventListener('focusout', this.onFocusOut.bind(this));
    }

    onButtonClick() {
      this.toggle(!this.open);
    }

    onFocusOut(e) {
      if (!this.toggleItem.contains(e.relatedTarget)) {
        this.toggle(!this.close);
      }
    }
    
    toggle(open) {
      if (open === this.open) {
        return;
      }

      this.open = open;
      this.toggleItem.classList.toggle('active');

      this.buttonEl.setAttribute('aria-expanded', `${open}`);
      if (open) {
        this.contentEl.removeAttribute('hidden');
      } else {
        this.contentEl.setAttribute('hidden', '');
      }
    }

    open() {
      this.toggle(true);
    }

    close() {
      this.toggle(false);
    }
  }

  class Checkbox {
    constructor(domNode) {
      this.domNode = domNode;
      this.domNode.tabIndex = 0;

      if (!this.domNode.getAttribute('aria-checked')) {
        this.domNode.setAttribute('aria-checked', 'false');
      }

      this.domNode.addEventListener('keydown', this.onKeydown.bind(this));
      this.domNode.addEventListener('keyup', this.onKeyup.bind(this));
      this.domNode.addEventListener('click', this.onClick.bind(this));
    }

    toggleCheckbox() {
      if (this.domNode.getAttribute('aria-checked') === 'true') {
        this.domNode.setAttribute('aria-checked', 'false');
      } else {
        this.domNode.setAttribute('aria-checked', 'true');
      }

      applyFilters();
    }

    onKeydown(event) {
      if (event.key === ' ') {
        event.preventDefault();
      }
    }

    onKeyup(event) {
      var flag = false;

      switch (event.key) {
        case ' ':
          this.toggleCheckbox();
          flag = true;
          break;

        default:
          break;
      }

      if (flag) {
        event.stopPropagation();
      }
    }

    onClick() {
      this.toggleCheckbox();
    }
  }

  const accordions = document.querySelectorAll('.faq .faq__item--toggle');
  accordions.forEach((accordionEl) => {
    new Toggle(accordionEl);
  });

  const filters = document.querySelectorAll('.filters');
  filters.forEach((filterBtn) => {
    new Toggle(filterBtn);
  });

  const filterItems = document.querySelectorAll('.filters__list-item');
  filterItems.forEach((filterItem) => {
    if (filterItem.classList.contains('filters__list-item--nse')) {
      new Toggle(filterItem);
    }
  });

  const checkboxes = document.querySelectorAll('.checkboxes [role="checkbox"]');
  checkboxes.forEach((checkbox) => {
    new Checkbox(checkbox);
  });

  const filterBtns = document.querySelectorAll('.filters__list-item-btn');
  const faqItems = document.querySelectorAll('.faq__item');
  const postItems = document.querySelectorAll('.post-filter-item');

  filterBtns.forEach((filter) => {
    filter.addEventListener('click', () => {
      applyFilters();
    });
  });

  document.getElementById('reset-filters')?.addEventListener('click', () => {
    filterBtns.forEach((filter) =>
      filter.setAttribute('aria-checked', 'false')
    );
    applyFilters();
  });

  function applyFilters() {
    const activeFilters = Array.from(filterBtns).filter(
      (filter) => jQuery(filter).attr('aria-checked') === 'true'
    );

    faqItems.forEach((item) => {
      if (activeFilters.length === 0) {
        jQuery(item).show('2000');
      } else {
        const showItem = activeFilters.some(
          (activeFilter) =>
            activeFilter.getAttribute('data-filter') ===
              item.getAttribute('data-product') ||
            item
              .getAttribute('data-category')
              .includes(activeFilter.getAttribute('data-filter'))
        );
        showItem ? jQuery(item).show('2000') : jQuery(item).hide('2000');
      }
    });

    postItems.forEach((item) => {
      if (activeFilters.length === 0) {
        jQuery(item).fadeIn('2000');
      } else {
        const showItem = activeFilters.some(
          (activeFilter) =>
            activeFilter.getAttribute('data-filter') ===
              item.getAttribute('data-product') ||
            activeFilter.getAttribute('data-filter') ===
              item.getAttribute('data-category')
        );
        showItem ? jQuery(item).fadeIn('2000') : jQuery(item).fadeOut('2000');
      }
    });
  }
}
